import { Option, SelectInputOptions } from 'components/form/select-input/types'

/** Type guard for use with the onChange prop on SelectInput component */
export const isOption = (
  selected: Option | SelectInputOptions | null
): selected is Option => {
  return !!selected && 'value' in selected
}
